import React, { useState } from 'react';
import './footer.css';
import logo from '../../assets/footerLogoTwo.svg';
import icon1 from '../../assets/indeed_icon.svg';
import icon2 from '../../assets/instagram_icon.svg';
import icon3 from '../../assets/facebook_icon.svg';
import icon4 from '../../assets/twitter_icon.svg';
import icon5 from '../../assets/youtube_icon.svg';
import $ from 'jquery';
import { baseVar } from '../../Global/GlobalVariable';
// import naga from "../../assets/"

function Footer({ data }) {
	const today = new Date();
	const year = today.getFullYear();

	var el = document.querySelectorAll('.displayShowMore');
	for (var i = 0; i < el.length; i++) {
		el[i].onclick = function () {
			var dataId = this.getAttribute('data-id');
			if (this.textContent == 'show less -') {
				this.textContent = 'show more +';
			} else {
				this.textContent = 'show less -';
			}
			$('.less_' + dataId).toggle();
		};
	}

	var data_fn = 0;
	return (
		<div className='fade_in'>
			<div className='footer mt-5 pt-5'>
				<div className='container'>
					<div className='row'>
						<div className='col text-start'>
							<ul className='footer-uls'>
								<li className='text-decoration-none'>
									<div className='d-flex'>
										<a title='eauditor office' href={baseVar}>
											<img
												style={{ width: '113px', height: ' 13px' }}
												src={logo}
												alt='eauditor office'
												title='eauditor office'
											/>
										</a>

										<a
											title='Linkedin'
											href='https://www.linkedin.com/company/e-auditor-office'
											target='_blank'
											rel='noopener noreferrer'>
											<img
												className='footer_icon mx-3'
												src={icon1}
												alt='Linkedin'
												title='Linkedin'
											/>
										</a>

										<a
											title='instagram'
											href='https://www.instagram.com/eauditoroffice/'
											target='_blank'
											rel='noopener noreferrer'>
											<img
												className='footer_icon me-3'
												src={icon2}
												alt='instagram'
												title='instagram'
											/>
										</a>
										<a
											title='facebook'
											href='https://www.facebook.com/eauditoroffice'
											target='_blank'
											rel='noopener noreferrer'>
											<img
												className='footer_icon me-3'
												src={icon3}
												alt='facebook'
												title='facebook'
											/>
										</a>
										<a
											title='twitter'
											href='https://twitter.com/eauditoroffice/'
											target='_blank'
											rel='noopener noreferrer'>
											<img
												className='footer_icon me-3'
												src={icon4}
												alt='twitter'
												title='twitter'
											/>
										</a>
										<a
											title='youtube'
											href='https://www.youtube.com/c/eAuditorOfficePrivateLimited'
											target='_blank'
											rel='noopener noreferrer'>
											<img
												className='footer_icon'
												src={icon5}
												alt='youtube'
												title='youtube'
											/>
										</a>
									</div>
								</li>
							</ul>
						</div>
					</div>
					<div className='row'>
						{data.map((res, i) => {
							let data = 0;
							data_fn++;
							return (
								<div key={i} className=' col-lg-3 col-md-6 col-6 text-start '>
									<ul className='footer-uls d-flex flex-column mt-5  '>
										<li>
											<p className='text-white fw-bold mb-2'>
												{res.service_head_name}
											</p>
										</li>

										<li
											className='read-more-state text-white'
											id={res.service_head_name}
											type='checkbox'
										/>
										{/* <div className='read-more-wrap'> */}
										{res.service_list_group.map((res, i) => {
											return (
												<ul className='ps-0' key={i}>
													{res.submenu.map((res, i) => {
														data++;
														// return (
														// 	<li key={i}>
														// 		<a
														// 			title={res.service_name}
														// 			className='text-white text-decoration-none text_hover'
														// 			href={res.service_url}>
														// 			{res.service_name}
														// 		</a>
														// 	</li>
														// );

														if (data <= 5) {
															return (
																<li key={i}>
																	<a
																		title={res.service_name}
																		className='text-white text-decoration-none text_hover'
																		href={baseVar + '/' + res.service_url}>
																		{res.service_name}
																	</a>
																</li>
															);
														} else {
															return (
																<li
																	key={i}
																	className={' Show_Fn less_' + data_fn}>
																	<a
																		title={res.service_name}
																		className='text-white text-decoration-none text_hover'
																		href={baseVar + '/' + res.service_url}>
																		{res.service_name}
																	</a>
																</li>
															);
														}
													})}
												</ul>
											);
										})}
										<button
											className='ps-0 displayShowMore read-more-trigger bg-transparent border-0 text-white text-start text-decoration-underline footer_show_more_btn'
											data-id={data_fn}
											type='button'
											value='show more'>
											Show more +
										</button>
										{/* </div>
										<label
											className='read-more-trigger text-white'
											htmlFor={res.service_head_name}></label> */}
									</ul>
								</div>
							);
						})}
						<div className=' col-lg-3 col-md-6 col-6 text-start '>
							<ul className='footer-uls d-flex flex-column mt-5  '>
								<li>
									<p className='text-white fw-bold mb-2'>Useful Links</p>
								</li>

								<li className='read-more-state text-white' type='checkbox' />
								<div className='read-more-wrap'>
									<a
										title='Contact Us'
										className='text-white text-decoration-none text_hover mb-0'
										href={baseVar + '/contact-us'}>
										Contact Us
									</a>

									<a
										title='Privacy Policy'
										className='text-white text-decoration-none text_hover mb-0'
										href={baseVar + '/privacy-policy'}>
										Privacy Policy
									</a>

									<a
										title='Blog'
										className='text-white text-decoration-none text_hover mb-0'
										href={baseVar + '/blog'}>
										Blog
									</a>

									<a
										title='Sitemap'
										className='text-white text-decoration-none text_hover mb-0'
										href={baseVar + '/sitemap.html'}>
										Sitemap
									</a>
									<a
										title='About US'
										className='text-white text-decoration-none text_hover mb-0'
										href={baseVar + '/about-us'}>
										About US{' '}
									</a>
								</div>
							</ul>
						</div>
					</div>
				</div>
			</div>

			<div className='footer-btm pt-3 '>
				<div className='container'>
					<div className='d-flex flex-column justify-content-center'>
						<div>
							<p className='text-white'>
								<a
									title='privacy-policy'
									href='privacy-policy'
									className='text-decoration-none text-white'>
									Privacy Policy, Terms & Conditions, Payments, Cancellation and
									Refund Policy{' '}
								</a>
								<br />
								<small>© {year} All Rights Reserved</small>
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Footer;
